import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

import { ref, watch, computed, onMounted } from 'vue';

import router         from '@/router';

/********************************
 ************ VUETIFY ***********
 *******************************/
import { useTheme, useDisplay } from 'vuetify';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';

export default /*#__PURE__*/_defineComponent({
  __name: 'LangAndMenu',
  setup(__props) {

const { xs }= useDisplay();
const theme = useTheme();

/********************************
 ************ I18N **************
 *******************************/
let { locale, t } = useI18n();

/********************************
 ************ STORE *************
 *******************************/
const store = useStore();


const items           = ref([
  {title : computed( () => t('logout') )}
]);

const language        = ref([ 
  { title: computed(() => t('appBar.es')), value: 'es' },
  { title: computed(() => t('appBar.en')), value: 'en' },
])


const themeSwitch     = ref(false);

watch(themeSwitch,(p:boolean)=>{
  setTimeout(() => {
    localStorage.setItem('appTheme', p.toString());
    let themeSelect = '';
    p ? themeSelect = 'darkCustom' : themeSelect = 'lightCustom';
    theme.global.name.value = themeSelect;
  }, 100);
})


const pressItem       = (item:number) => {
  if(item === 0){
    router.push('/')
    setTimeout(()=>{
        localStorage.removeItem('user');
        localStorage.removeItem('rol');
        router.push('/login');
        store.commit('setAppBarPage','principalPage');
        store.commit('setUserSesion',null);

        //PARA CUANDO HAYAN 2 smartlink en el mismo lugar
        // router.push(`/principalPage`);
        // store.commit('setAppBarPage','principalPage');
    },200)
  }
  if(item === 1 ){
    if(theme.global.name.value === 'darkCustom'){
      theme.themes.value.darkCustom.colors.background = '#FF00FF'
    }
    if(theme.global.name.value === 'lightCustom'){
      theme.themes.value.lightCustom.colors.background = '#FF0000'
    }
  }
}

onMounted(() => {
  let themeSelect = '';
  localStorage.getItem('appTheme') === null ? localStorage.setItem('appTheme','true') : null;
  setTimeout(() => {
    themeSwitch.value = localStorage.getItem('appTheme')?.toString() === 'true'
    themeSwitch.value ? themeSelect = 'darkCustom' : themeSelect = 'lightCustom';
    theme.global.name.value = themeSelect;
  }, 500);
})


return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_openBlock(), _createBlock(_component_v_sheet, {
    class: "languageCard",
    color: "transparent"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        class: "ma-0 py-3",
        justify: "end",
        "align-content": "center"
      }, {
        default: _withCtx(() => [
          (!_unref(xs))
            ? (_openBlock(), _createBlock(_component_v_select, {
                key: 0,
                class: "languageSelect",
                modelValue: _unref(locale),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(locale) ? (locale).value = $event : locale = $event)),
                items: language.value,
                "item-title": "title",
                "item-value": "value",
                density: "compact",
                variant: "outlined",
                "hide-details": "",
                style: {"width":"110px !important"}
              }, null, 8, ["modelValue", "items"]))
            : _createCommentVNode("", true),
          _createVNode(_component_v_menu, {
            "close-on-content-click": false,
            transition: "slide-x-transition"
          }, {
            activator: _withCtx(({ props, isActive }) => [
              _createVNode(_component_v_btn, _mergeProps({
                "append-icon": isActive?'mdi-chevron-left':'mdi-chevron-down',
                color: "colorText"
              }, props), {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, { icon: "mdi-cog-outline" })
                ]),
                _: 2
              }, 1040, ["append-icon"])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_v_list, {
                lines: false,
                density: "compact",
                nav: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_switch, {
                        modelValue: themeSwitch.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((themeSwitch).value = $event)),
                        "append-icon": "mdi-weather-night",
                        "prepend-icon": "mdi-white-balance-sunny",
                        "hide-details": ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  (_unref(xs))
                    ? (_openBlock(), _createBlock(_component_v_list_item, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_select, {
                            class: "mb-3",
                            modelValue: _unref(locale),
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(locale) ? (locale).value = $event : locale = $event)),
                            items: language.value,
                            "item-title": "title",
                            "item-value": "value",
                            density: "compact",
                            variant: "outlined",
                            "hide-details": "",
                            style: {"width":"110px !important"}
                          }, null, 8, ["modelValue", "items"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, i) => {
                    return (_openBlock(), _createBlock(_component_v_list_item, {
                      style: 'text-align:center',
                      key: i,
                      link: "",
                      onClick: ($event: any) => (pressItem(i))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_title, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.title), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})